import { ContentWrapper, useStyles } from "./styles";

export default function UpdatePageContent(props: { content: String }) {
  const classes = useStyles();
  const { content } = props;

  return (
    <ContentWrapper
      dangerouslySetInnerHTML={{ __html: content }}
      className={classes.root}
    />
  );
}
